module.exports = __webpack_public_path__ + "static/media/224HO.a2e7c8fd.jpg";